import { render, staticRenderFns } from "./StatsCell.vue?vue&type=template&id=72ceabce&scoped=true&"
import script from "./StatsCell.vue?vue&type=script&lang=js&"
export * from "./StatsCell.vue?vue&type=script&lang=js&"
import style0 from "./StatsCell.vue?vue&type=style&index=0&id=72ceabce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ceabce",
  null
  
)

export default component.exports